import React from 'react';
import { shape, string, object } from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from '../elements';

const BrandCard = ({ brand, logo, path }) => {
  const linkPath = `/guides/${path}/models/`;

  return (
    <Link
      id={`brand-card-${brand.toLowerCase().split(' ').join('-')}`}
      path={linkPath}
      classnames="border border-grey-light hover:border-grey-medium rounded-lg shadow-lg text-center p-6 font-normal flex flex-col align-middle no-underline"
      segmentProperties={{
        section: 'article',
        style: 'card',
        text: brand,
        path,
      }}
    >
      <div className="h-16 flex flex-col justify-center items-center m-0-auto">
        {logo && logo.gatsbyImageData ? (
          <GatsbyImage
            image={logo.gatsbyImageData}
            alt=""
            className="max-h-full max-w-32"
            imgClassName="max-h-full m-0-auto"
          />
        ) : logo && logo.url ? (
          <img src={logo.url} alt="" className="max-h-full max-w-32" />
        ) : null}
      </div>
      <p className="no-underline">{brand}</p>
    </Link>
  );
};

export default BrandCard;

BrandCard.propTypes = {
  brand: string.isRequired,
  logo: shape({
    // eslint-disable-next-line react/forbid-prop-types
    gatsbyImageData: object,
    url: string,
  }).isRequired,
  path: string.isRequired,
};
